import { render, staticRenderFns } from "./datatype.vue?vue&type=template&id=5ea7ee1e"
import script from "./datatype.vue?vue&type=script&lang=js"
export * from "./datatype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports